import * as React from 'react'

function SvgIconVersionMerge(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="version-merge" aria-labelledby="t-version-merge d-version-merge">
        <title id="t-version-merge">{'Merge version'}</title>
        <desc id="d-version-merge">
          {'Two vertical parallel lines converge in a point'}
        </desc>
        <path d="M9 24.2V10.8c1.2-.4 2-1.5 2-2.8s-.8-2.4-2-2.8V0H7v5.2C5.8 5.6 5 6.7 5 8s.8 2.4 2 2.8v13.4c-1.2.4-2 1.5-2 2.8s.8 2.4 2 2.8V32h2v-2.2c1.2-.399 2-1.5 2-2.8s-.8-2.4-2-2.8zM6 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm2 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        <path d="M25 24.2V15c0-4.4-3.6-8-8-8h-2.6l5.3-5.3c.399-.4.399-1 0-1.4-.4-.4-1-.4-1.4 0l-7 7c-.4.4-.4 1 0 1.4l7 7c.4.4 1 .4 1.4 0 .399-.4.399-1 0-1.4L14.4 9H17c3.3 0 6 2.7 6 6v9.2c-1.2.399-2 1.5-2 2.8s.8 2.4 2 2.8V32h2v-2.2c1.2-.399 2-1.5 2-2.8s-.8-2.4-2-2.8zM24 29c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
      </g>
    </svg>
  )
}

export default SvgIconVersionMerge
